<template>
  <div>
    <v-dialog v-model="processing" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by - request is being processed
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <manual-adjustment ref="manual"></manual-adjustment>
    <v-row>
      <v-col md="6" v-if="run.runId">
        <v-btn
          color="primary"
          @click="MakeInitials(run)"
        >(Re)Create {{ run.runType == 1 ? "Initials" : "Royalty" }}</v-btn>
        <v-btn color="primary" @click="RunAllReports(run)">Run All Reports</v-btn>
        <v-btn color="primary" @click="SummaryReport(run)">Summary Report</v-btn>
        <v-btn color="primary" @click="Download(run)">Download Reports</v-btn>
        <v-btn color="primary" @click="AddManual(run)">Add Manual Entry</v-btn>
      </v-col>
    </v-row>
    <v-row v-if="missingPlans && missingPlans.length > 0">
      <v-col>
        <h2>Missing Plans</h2>
        <v-data-table :headers="headers" :items="missingPlans">
          <template v-slot:item.servicePlanNo="{ item }">
            <td>
              <v-btn small color="primary" @click="addRatePlan(item)">Add Rate Plan</v-btn>
            </td>
          </template>
          <template slot="pageText" slot-scope="props">
            Lines {{ props.pageStart }} - {{ props.pageStop }} from
            {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row v-show="addPlan">
      <v-col>
        <add-rule ref="addRule"></add-rule>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import addRule from "@/components/commissions/AddRule";
import ManualAdjustment from "@/components/commissions/ManualAdjustment";
export default {
  name: "ListCommissions",
  components: {
    addRule,
    ManualAdjustment
  },
  data() {
    return {
      processing: false,
      missingPlans: null,
      addPlan: null,
      headers: [
        { text: "Service Plan Description", value: "servicePlanDescription" },
        { text: "CSN", value: "csn" },
        { text: "CustNo", value: "customerNumber" },
        { text: "Service Date Added", value: "serviceDateAdded" },
        {
          text: "Service Date Disconnected",
          value: "serviceDateDisconnected"
        },
        {
          text: "Usage Type",
          value: "usageType"
        },
        { text: "Actions", value: "servicePlanNo" }
      ]
    };
  },
  computed: {
    ...mapFields("commissions", ["run"])
  },
  methods: {
    ...mapActions("commissions", [
      "CreateReports",
      "CreateInitials",
      "CreateSummaryReport",
      "DownloadReports"
    ]),
    addRatePlan(val) {
      this.$refs.addRule.populate(val);
    },
    Download(value) {
      this.DownloadReports(value).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Commissions${this.run.runId}.zip`); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },

    SummaryReport(run) {
      this.processing = true;
      this.CreateSummaryReport(run)
        .then(response => {
          this.processing = false;
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `CommissionsSummary${this.run.runId}.pdf`
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          this.processing = false;
        });
    },
    RunAllReports(selection) {
      this.processing = true;
      this.CreateReports(selection)
        .then(() => {
          this.processing = false;
        })
        .catch(() => {
          this.processing = false;
        });
    },
    MakeInitials(runID) {
      let vm = this;
      this.processing = true;
      vm.missingPlans = [];
      this.CreateInitials(runID)
        .then(data => {
          this.processing = false;
          if (data.type == "missingPlans") {
            vm.missingPlans = data.data;
          }
          vm.$emit("makeInitials", data);
        })
        .catch(() => {
          this.processing = false;
        });
    },

    AddManual(run) {
      let manual = this.$refs["manual"];
      manual.dialog = true;

      manual.editedItem = {
        amount: 0,
        chargeLineid: 0,
        comment: "",
        csn: "",
        custAdded: null,
        custNo: 0,
        custRequired: null,
        dealerElligibleTotal: null,
        dealerId: 0,
        eligibleAmount: null,
        elligibleIpbonus: null,
        id: 0,
        ipbonusAmt: null,
        manualEntry: true,
        percentageApplied: null,
        ratePlanId: 0,
        runDate: new Date(),
        runId: run.runId,
        runType: run.runType,
        servicesAddedThisMonth: null,
        summaryLevel: 1
      };
    }
  }
};
</script>

<style scoped></style>
